import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Content } from 'console/sim/context';
import { useParams } from 'react-router-dom';
import { Alert, AlertTitle, Box, Button, Skeleton } from '@mui/material';
import { SimOrderForm } from 'console/sim/order-sim/order-form';
import { BillingPayCard } from 'console/billing/widgets';
import { LocalShippingRounded } from '@mui/icons-material';
import { useNavigateRoot } from 'shared/hooks/router';
export function InvoiceOrderTariff() {
    const { sim_tariffs } = useContext(Content);
    const { sim_id, operator } = useParams();
    const onRoot = useNavigateRoot();
    if (!sim_id || !operator) {
        return (_jsxs(Alert, { severity: "error", children: ["\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u0430 \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0430.", _jsx(Button, { onClick: onRoot, children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E" })] }));
    }
    return (_jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", gap: 2, boxSizing: "border-box", children: [_jsxs(Alert, { severity: "warning", children: [_jsx(AlertTitle, { children: "\u041D\u0430 \u0432\u0430\u0448\u0435\u0439 \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0435 \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E" }), "\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E, \u0434\u0435\u043D\u044C\u0433\u0438 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443 \u043E\u0441\u0442\u0430\u043D\u0443\u0442\u0441\u044F \u0443 \u0412\u0430\u0441 \u043D\u0430 \u0441\u0447\u0435\u0442\u0443!"] }), _jsx(SimOrderForm, { payButton: (order_state, onPreCheck) => sim_tariffs.loading || !sim_tariffs.sim_shipping_x100 ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 40 })) : (_jsx(BillingPayCard, { pay_props: {
                        price_x100: sim_tariffs.sim_shipping_x100,
                        pay_intent: {
                            type: 'free_sim_shipping',
                            sim_id: { id: sim_id, operator },
                            fio: order_state.fio,
                            phone: order_state.phone,
                            post_index: order_state.postindex,
                            address: order_state.address,
                        },
                        button_props: {
                            startIcon: _jsx(LocalShippingRounded, {}),
                            color: 'info',
                        },
                        onPreCheck,
                        enough_text: 'Оформить доставку',
                    } })) })] }));
}
